import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { selectUpdate, updateGroupHistoricDataViewSettings } from '~/ProductGroup';
import { State } from '~/Store';
import { Statuses } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import Settings from './Settings';

interface OwnProps {
	group: UserProductGroup;
}

function mapStateToProps({ productGroup }: State, { group }: OwnProps) {
	return {
		updateStatus: selectUpdate(productGroup, group.id) !== null ? Statuses.saving : null,
	};
}

const actions = {
	onUpdate: updateGroupHistoricDataViewSettings,
};

export default connect(mapStateToProps, actions)(Settings);
